import actions from './actions'
import featureLimit from './metaData/featureLimit'
export default {
  state: featureLimit,
  actions
}
